var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-vue-search-box-container",
      on: {
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            return _vm.selectTip("up")
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            ) {
              return null
            }
            return _vm.selectTip("down")
          },
        ],
      },
    },
    [
      _c(
        "div",
        { staticClass: "search-box-wrapper" },
        [
          _c("el-input", {
            attrs: { clearable: "", placeholder: "请输入" },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.search.apply(null, arguments)
              },
              input: _vm.autoComplete,
            },
            model: {
              value: _vm.keyword,
              callback: function ($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "search-tips" }, [
        _c(
          "ul",
          _vm._l(_vm.tips, function (tip, index) {
            return _c(
              "li",
              {
                key: index,
                class: { "autocomplete-selected": index === _vm.selectedTip },
                on: {
                  click: function ($event) {
                    return _vm.changeTip(tip)
                  },
                  mouseover: function ($event) {
                    _vm.selectedTip = index
                  },
                },
              },
              [_vm._v(_vm._s(tip.name))]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }